import { MenuTypes } from '@/models/Menu/Constants'

export const getOrderDescription = campaign => {
  if (!campaign.menu) {
    return campaign.menuSetting
  }
  if (campaign.menu.menuType === MenuTypes.Railway) {
    return campaign.menuSetting.orderDescription.target.railwayStationTargetObj
  }
  if (campaign.menu.menuType === MenuTypes.CustomGeo) {
    return campaign.menuSetting.orderDescription
  }
  return campaign.menuSetting
}
